import { useEffect, useRef } from "react";

// Fully uncontrolled input: never writes back into the element while the user is
// interacting (prevents Edge/Chromium color-picker + eyedropper freezes), and
// debounces commits so heavy re-renders only happen when the user pauses.
export default function DebouncedInput({ value, onCommit, delay = 300, ...props }) {
  const ref = useRef(null);
  const timer = useRef(null);
  const commitRef = useRef(onCommit);
  commitRef.current = onCommit;

  useEffect(() => {
    const el = ref.current;
    if (el && document.activeElement !== el && String(el.value) !== String(value)) {
      el.value = value;
    }
  }, [value]);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const schedule = (e) => {
      const v = e.target.value;
      clearTimeout(timer.current);
      timer.current = setTimeout(() => commitRef.current(v), delay);
    };
    el.addEventListener("input", schedule);
    el.addEventListener("change", schedule);
    return () => {
      el.removeEventListener("input", schedule);
      el.removeEventListener("change", schedule);
      clearTimeout(timer.current);
    };
  }, [delay]);

  return <input ref={ref} defaultValue={value} {...props} />;
}
